import ButtonComponent from "@button/App.vue";
import storeGlobal from "@/store";
export default {
  component: ButtonComponent,
  router: "",
  store: storeGlobal,
};
